import React from "react";
import styled from "styled-components";
import { colors } from "./colors";

export const SEVERITY_STYLES = {
    critical: { label: "Critical", background: colors.criticalSoft, ink: colors.criticalInk, dot: colors.critical },
    high: { label: "High", background: colors.warningSoft, ink: colors.warningInk, dot: colors.warning },
    medium: { label: "Medium", background: colors.cautionSoft, ink: colors.cautionInk, dot: colors.caution },
};

export default function SeverityBadge({ severity }) {
    const style = SEVERITY_STYLES[severity];
    return (
        <Badge $background={style.background} $ink={style.ink}>
            <Dot $color={style.dot} />
            {style.label}
        </Badge>
    );
}

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    border-radius: 6px;
    padding: 2px 8px;
    font-size: 12px;
    font-weight: 500;
    background: ${({ $background }) => $background};
    color: ${({ $ink }) => $ink};
`;

export const Dot = styled.span`
    width: ${({ $size = 6 }) => $size}px;
    height: ${({ $size = 6 }) => $size}px;
    border-radius: 999px;
    flex-shrink: 0;
    background: ${({ $color }) => $color};
`;
